<div id="parent" style="width: 100%; height: auto;">

    <div id="suspects-heatmap-headers-main">
        <div id="suspects-heatmap-headers">
            <div class="suspects-heatmap-header1">
                {{header1_line1}}<br/>
            </div>
            <div class="suspects-heatmap-header2">{{header2}}</div>
            <div class="suspects-heatmap-header3">
                {{header3_line1}}<br/>
                {{header3_line2}}
            </div>
        </div>
        <div id="suspects-heatmap-export">
            <dx-button icon="exportxlsx" class="ap-blue-btn"
                (onClick)="exportExcel($event)" text="Export to Excel">
            </dx-button>
        </div>
    </div>
    <div>
        <h6 style="margin-left: 15px" class="ap-green">{{header5}}</h6>
    </div>
    <div class="suspects-heatmap-container">                      
        <div id="suspects-heatmap1-viewport" class="suspects-heatmap-viewport" [class.info-text]="showInfoText"></div>
        <div style="margin-right: 15px"></div>
        <div id="suspects-heatmap1-legend" class="suspects-heatmap-legend" [hidden]="hideLegend1">
        </div>
    </div>
    <div style="margin-top: 20px;"></div>
    <h6 style="margin-left: 15px" class="ap-green">{{header4}}</h6>
    <div style="margin-top: 20px;"></div>
    <div class="suspects-heatmap-container">                      
        <div id="suspects-heatmap2-viewport" class="suspects-heatmap-viewport" [class.info-text]="showInfoText"></div>
        <div style="margin-right: 15px"></div>
        <div id="suspects-heatmap2-legend" class="suspects-heatmap-legend" [hidden]="hideLegend2">
            <b>MVA MT/day</b>
            <hr />
        </div>
    </div>
</div>